import { Bone, Group, Mesh, SkinnedMesh } from "three";
import { ThreeUtils } from "@utils/ThreeUtils";

type Handle = {
    root: Group | null;
    meshes: Record<string, Mesh | SkinnedMesh | Bone>;
};
export class GLTFJSXUtils {
    static createHandle<H extends Handle, T extends H["meshes"] = H["meshes"]>(props: Omit<H, "meshes">, nodes: T) {
        const handle = { ...props } as H;
        Object.defineProperty(handle, "meshes", {
            get: () => {
                const meshes = {} as T;
                if (!props.root) return meshes;
                props.root.traverse((child) => {
                    if (!ThreeUtils.isMesh(child)) return;
                    for (const key in nodes) {
                        if (child.name !== key) continue;
                        meshes[key] = child as any;
                        break;
                    }
                });
                return meshes;
            }
        });
        return handle;
    }
}